module.exports = "<div *ngIf='utils.authenticated'>\n  <div class='editor'>\n    <span\n        [innerHTML]='email'></span>\n  </div>\n  <button class='logout'\n      (click)=\"utils.logout()\">Log Out</button>\n</div>\n\n<div *ngIf='!utils.authenticated'>\n  <button (click)=\"utils.login()\">Log In</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login-box/login-box.component.html
// module id = 428
// module chunks = 0